import user_icon from '../img/icon/user-icon.svg';

const Chat = ({ descendingOrderMessages, user, otherUser }) => {
    return (
        <>
            <div className="chat-display">
                {descendingOrderMessages.map((message, _index) => {
                    // Determine if the current message is from the logged-in user
                    const isCurrentUser = user?.user_id === message.from_userId;

                    // Get the image source safely
                    const profilePic = isCurrentUser
                        ? (user?.pic || user_icon)
                        : (otherUser?.pic || user_icon);
                    const message_class = isCurrentUser ? "message-own" : "message-other-user"
                    return (
                        <div key={_index}>
                            <div className={message_class}>
                                <div className="img-container">
                                    <img src={profilePic} alt="profile pic" />
                                    <p>{message.message}</p>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};


export default Chat